// @flow
export const MODULE_NAME = 'adyen';
export const COMMON_FORM_NAME = `${MODULE_NAME}_PAYMENT_FORM`;

export const ADYEN_PAYMENT_CC = 'credit_card';
export const ADYEN_PAYMENT_SEPA = 'sepadirectdebit';
export const ADYEN_PAYMENT = 'AdyenRecurringContract';
